import { useEffect, useState } from "react";
import { Check, Gift, Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

const PERKS = ["Unique survey link & printable QR code", "Unlimited customer responses", "Instant email alerts for reviews under 3 stars", "Live dashboard with averages & sorting"];

export const Paywall = ({ location }) => {
  const canceled = location.subscription_status === "canceled";
  const [loading, setLoading] = useState(false);
  const [trial, setTrial] = useState(false);
  useEffect(() => { api.get("/payments/eligibility").then((r) => setTrial(r.data.trial_eligible)).catch(() => {}); }, []);
  const trialEnd = new Date(Date.now() + 30 * 864e5).toLocaleDateString(undefined, { month: "short", day: "numeric" });
  const checkout = async () => {
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", { origin_url: window.location.origin, location_id: location.id });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(errMsg(e));
      setLoading(false);
    }
  };
  return (
    <div className="max-w-xl rounded-3xl border border-slate-200/80 bg-white p-6 sm:p-10 shadow-sm fade-up" data-testid="paywall-card">
      <span className="inline-flex items-center gap-1.5 rounded-full bg-[#E3EDE6] text-[#244A3B] px-3 py-1 text-xs font-bold uppercase tracking-wide">
        <Lock className="w-3.5 h-3.5" /> {canceled ? "Subscription inactive" : "One last step"}
      </span>
      {trial && (
        <span className="ml-2 inline-flex items-center gap-1.5 rounded-full bg-[#E3EEF3] text-[#2E6F8E] px-3 py-1 text-xs font-bold uppercase tracking-wide" data-testid="paywall-trial-badge">
          <Gift className="w-3.5 h-3.5" /> First month free
        </span>
      )}
      <h2 className="mt-4 font-display text-2xl sm:text-3xl font-extrabold tracking-tight" data-testid="paywall-location-name">Activate {location.label}</h2>
      <p className="mt-2 text-[#4B5A54]">Each location has its own subscription, survey link, QR code and feedback dashboard.</p>
      <div className="mt-6 flex items-baseline gap-1">
        <span className="font-display text-5xl font-extrabold tracking-tight">$29.99</span>
        <span className="text-[#778580] font-medium">/ month for this location</span>
      </div>
      {trial && <p className="mt-2 text-sm font-semibold text-[#2E6F8E]" data-testid="paywall-trial-note">$0 today. Your 1-month free trial ends {trialEnd}, then $29.99/month.</p>}
      <ul className="mt-6 space-y-2.5">
        {PERKS.map((p) => (
          <li key={p} className="flex items-start gap-2.5 text-sm text-[#1A2B25]">
            <span className="mt-0.5 grid place-items-center w-5 h-5 rounded-full bg-[#E3EEF3] text-[#2E6F8E]"><Check className="w-3 h-3" /></span>{p}
          </li>
        ))}
      </ul>
      <button onClick={checkout} disabled={loading} className="btn-primary w-full justify-center mt-8 !py-3.5 text-base" data-testid="stripe-checkout-button">
        {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : trial ? "Start my free month" : "Subscribe with Stripe — $29.99/mo"}
      </button>
      <p className="mt-3 text-center text-xs text-[#778580]">{trial ? "Card required. Cancel before the trial ends and you won't be charged." : "Secure checkout by Stripe. Cancel anytime."}</p>
    </div>
  );
};
